import { render, staticRenderFns } from "./InpaintCanvas.vue?vue&type=template&id=94512c1e&scoped=true"
import script from "./InpaintCanvas.vue?vue&type=script&lang=js"
export * from "./InpaintCanvas.vue?vue&type=script&lang=js"
import style0 from "./InpaintCanvas.vue?vue&type=style&index=0&id=94512c1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94512c1e",
  null
  
)

export default component.exports